export enum AnalyseProfilesActionTypes {
  CHANGE_COUNTRY = '[Analyse Profiles] Change Country',
  NEXT_PAGE = '[Analyse Profiles] Next Profile Page',
  PREVIOUS_PAGE = '[Analyse Profiles] Previous Profile Page',
  RELOAD_APP = '[Analyse Profiles] Reload App',
  RESET = '[Analyse Profiles] Reset Profiles Content',
  RETRY_LOAD = '[Analyse Profiles] Retry loading Profile Content',
}

export interface AnalyseProfilesChangeCountryPayload {
  /**
   * Two character country code for the country whose insights are to be shown,
   * e.g. 'DE', 'CA'.
   */
  countryCode: string;
}

export class AnalyseProfilesChangeCountry {
  public readonly type = AnalyseProfilesActionTypes.CHANGE_COUNTRY;
  constructor(public payload: AnalyseProfilesChangeCountryPayload) {}
}

export class AnalyseProfilesNextPage {
  public readonly type = AnalyseProfilesActionTypes.NEXT_PAGE;
}

export class AnalyseProfilesPreviousPage {
  public readonly type = AnalyseProfilesActionTypes.PREVIOUS_PAGE;
}

export class AnalyseProfilesReloadApp {
  public readonly type = AnalyseProfilesActionTypes.RELOAD_APP;
}

export class AnalyseProfilesReset {
  public readonly type = AnalyseProfilesActionTypes.RESET;
}

export class AnalyseProfilesRetryLoad {
  public readonly type = AnalyseProfilesActionTypes.RETRY_LOAD;
}

export type AnalyseProfilesActionUnion =
  | AnalyseProfilesChangeCountry
  | AnalyseProfilesNextPage
  | AnalyseProfilesPreviousPage
  | AnalyseProfilesReloadApp
  | AnalyseProfilesReset
  | AnalyseProfilesRetryLoad;
